import React from 'react';
import { useParams } from 'react-router-dom';
import { StyleSheet, Text, View } from './components/base_components';
import BreadcrumbPath from './components/breadcrumb_path';
import StandardBoxList from './components/standard_box_list';
import StandardScreen from './components/standard_screen';
import TitleActionLine from './components/title_action_line';
import VolumeTabBar from './components/volume_tab_bar';

import AuditStore from './stores/audit_store';
import UserStore from './stores/user_store';
import VolumeStore from './stores/volume_store';

import { dateFormat } from './tools/util';

const styles = StyleSheet.create({
  volumeAuditScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  tabBar: {
    marginLeft: '2rem',
    marginRight: '2rem',
  },
  emptyListText: {
    margin: '2rem',
    color: '#666',
    fontSize: '1.5rem',
  },
});
export default function VolumeAuditScreen(props) {
  const params = useParams();
  const org = UserStore.useOrg();
  const path = '/' + (params['*'] ?? '');
  const volume_id = parseInt(params.volume_id ?? '0', 10) || 0;
  const volume = VolumeStore.useVolume(org?.org_id, volume_id);
  const audit_list = AuditStore.useVolumeList(volume_id);

  React.useEffect(() => {
    VolumeStore.fetch(org?.org_id);
  }, [org?.org_id]);
  React.useEffect(() => {
    AuditStore.fetchVolume({ volume_id, org_id: org?.org_id });
  }, [org?.org_id, volume_id]);
  const rows = audit_list?.map?.((item) => {
    let list = [dateFormat(item.create_time)];
    let url = `/volume/${volume_id}${item.media_path}`;
    if (
      item.device_id &&
      item.user_id &&
      item.media_path === 'volume_encryption_key'
    ) {
      list.push(
        item.user_name || item.email,
        'Device: ' + item.device_name,
        'Volume Key Download'
      );
    } else if (!item.dest_path) {
      list.push(
        item.device_name || item.user_name || item.email,
        item.media_path,
        'Web Download'
      );
    } else {
      url = `/volume/${volume_id}${item.media_path}`;
      list.push(
        item.device_name || item.user_name || item.email,
        item.media_path,
        item.dest_path
      );
    }
    return { url, list };
  });
  return (
    <View style={styles.volumeAuditScreen}>
      <StandardScreen>
        <BreadcrumbPath
          volumeName={volume?.volume_name}
          prefix={`/volume/${volume_id}/`}
          path={path}
          extra='Audit'
        />
        <TitleActionLine title={volume?.volume_name} />
        <VolumeTabBar style={styles.tabBar} volumeId={volume_id} path={path} />
        <StandardBoxList
          title='Audit Tracking'
          detail={audit_list?.length ?? 0}
          headers={['Timestamp', 'User', 'Source', 'Destination']}
          sizes={[1, 2, 3, 3]}
          linkColumn={2}
          rows={rows}
        >
          {audit_list?.length === 0 ? (
            <Text style={styles.emptyListText}>No audit events found.</Text>
          ) : null}
        </StandardBoxList>
      </StandardScreen>
    </View>
  );
}
